const path = require('path');

export const Mixin = {
    methods: {
        removeTagsFromString: function (str) {
            var div = document.createElement("div");
            div.innerHTML = str;
            str = div.textContent || div.innerText || "";
            return str.replace(/\r?\n/g, '');
        },
        getHeadMetaFromPost: function (post, og_type) {
            let title, description, canonical, shortlink;

            if (og_type) {
                og_type = "website";
            }

            let image = this.getImg('img/ogp.png');
            let image_width = 1200;
            let image_height = 630;
            let twitter_card = "summary_large_image";

            if (post) {

                let yoast_meta = post.yoast_meta;
                if (yoast_meta) {
                    title = yoast_meta.yoast_wpseo_title;
                    description = yoast_meta.yoast_wpseo_metadesc;
                    canonical = yoast_meta.yoast_wpseo_canonical;
                }
                if (!title) {
                    title = post.title.rendered;
                }
                if (!description) {
                    description = post.content.rendered;
                }
                if (!canonical) {
                    canonical = location.origin + current_route.path;
                }

                shortlink = post.guid.rendered;
                let current_route = this.$router.currentRoute;

                if (post.type == "material") {
                    image = this.getMaterialUrl(post.slug + '.png', '-ogp');
                    // twitter_card = "";
                    image_width = 1200;
                    image_height = 630;
                }

                // og_type = "";
                // console.log(current_route);
                // const url = this.$router.resolve({
                //     name: 'Material',
                //     params: {
                //         postSlug: post.slug
                //     }
                // });
                // console.log(location.origin + url.href);
            } else {
                title = "のびのびそざい";
                description = "商用・非商用問わずすべて無料の雑な手書き素材。クレジット表記・リンク一切不要。WEBサイト・ブログ・チラシなどに使用できます。SVG・PNG・JPGなど形式多数。";
                shortlink = "https://sozai.nobi.site/";
                canonical = "https://sozai.nobi.site/";
            }
            title = this.removeTagsFromString(title);
            description = this.removeTagsFromString(description);
            // canonical = canonical;
            // console.log(canonical,post);
            return {
                title: {
                    inner: title,
                    separator: '|',
                    complement: '雑な手書きの無料フリー素材'
                },
                link: [{
                    rel: 'shortlink',
                    href: shortlink,
                    id: 'shortlink',
                }, {
                    rel: 'canonical',
                    href: canonical,
                    id: 'canonical',
                }, ],
                meta: [
                    //default
                    {
                        name: 'description',
                        content: description,
                        id: 'description',
                    },
                    //fb
                    {
                        property: 'og:title',
                        content: title,
                        id: 'og-title',
                    },
                    {
                        property: 'og:description',
                        content: description,
                        id: 'og-description',
                    },
                    {
                        property: 'og:type',
                        content: og_type,
                        id: 'og-type',
                    },
                    {
                        property: 'og:image',
                        content: image,
                        id: 'og-image',
                    },
                    {
                        property: 'og:image:secure_url',
                        content: image,
                        id: 'og-image-secure_url',
                    },
                    {
                        property: 'og:image:width',
                        content: image_width,
                        id: 'og-image-width',
                    },
                    {
                        property: 'og:image:height',
                        content: image_height,
                        id: 'og-image-height',
                    },
                    {
                        property: 'og:url',
                        content: canonical,
                        id: 'og-url',
                    },
                    //tw
                    {
                        name: 'twitter:card',
                        content: twitter_card,
                        id: 'twitter-card',
                    },
                    {
                        name: 'twitter:image',
                        content: image,
                        id: 'twitter-image',
                    },
                    {
                        name: 'twitter:description',
                        content: description,
                        id: 'twitter-description',
                    },
                    {
                        name: 'twitter:title',
                        content: title,
                        id: 'twitter-title',
                    },
                    {
                        name: 'twitter:site',
                        content: "@nobi_lab",
                        id: 'twitter-site',
                    },
                    {
                        name: 'twitter:creator',
                        content: "@nobi_lab",
                        id: 'twitter-creator',
                    },
                ],
            }
        },
        getImg: function (src) {
            let theme = process.env.VUE_APP_WP_THEME_DIR;
            // console.log("getImg", theme, src);
            let img = require("./assets/" + src);
            return theme + "dist/" + img;
        },
        getMaterialUrl: function (file, ogp) {
            if (!ogp) {
                ogp = "";
            }
            let base_path = process.env.VUE_APP_MATERIAL_URL_BASE;
            let filename = path.basename(file);
            let ext = path.extname(filename);
            let dir = path.basename(filename, ext);
            filename = dir + ogp + "" + ext;
            return base_path + 'material/' + dir + '/' + filename;
        },
        getMaterialDLUrl: function (file) {
            let dl_path = process.env.VUE_APP_MATERIAL_URL_DOWNLOAD;
            let filename = path.basename(file);
            let ext = path.extname(filename);
            let dir = path.basename(filename, ext);
            return dl_path + 'material/' + dir + '/' + filename;
        },

        toTop: function () {
            // console.log("toTop");
            // or alternatively inside your components you can use
            let element = "";
            let options = {
                offset: 0,
            };
            let cancelScroll = this.$scrollTo(element, 300, options)
            // goTo(0, {
            //     duration: 500
            // });
        }
    }
}